import annotation from './annotation';

export default annotation;
